var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnify = function SvgMagnify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.696 27.613c6.916 0 12.556-5.641 12.556-12.556 0-6.916-5.64-12.556-12.556-12.556S3.14 8.142 3.14 15.058c0 6.915 5.64 12.555 12.556 12.555zM36.681 36.041 24.993 24.354"
  }))));
};
export default SvgMagnify;